<template>
    <div class="products-table">
        <div class="products-table__header">
            <el-input
                v-model="search"
                prefix-icon="el-icon-search"
                placeholder="Type to search"
                class="search-bar"
                clearable
                @keyup.native="$emit('change:search-products', search)"
            />
            <el-button
                v-if="allowImportCsv"
                type="secondary"
                @click="$emit('click:import-products')"
                >Import from CSV
            </el-button>
            <el-button type="primary" @click="$emit('click:add-product')"
                >Add Product
            </el-button>
        </div>
        <el-table
            v-loading="isLoading"
            :data="productsData"
            :height="height"
            style="width: 100%"
            class="base-table"
            row-class-name="products-table__row"
        >
            <el-table-column prop="name" label="Product Name">
                <template slot-scope="{ row }">
                    <highlight-search :word="row.name" :search="search" />
                </template>
            </el-table-column>
            <el-table-column prop="brand" label="Brand">
                <template slot-scope="{ row }">
                    <highlight-search :word="row.brand" :search="search" />
                </template>
            </el-table-column>
            <el-table-column prop="supplierName" label="Supplier" />
            <el-table-column width="180">
                <el-row slot-scope="props" type="flex" justify="end">
                    <el-button
                        size="mini "
                        @click="$emit('click:edit-product', props.row)"
                        >Edit</el-button
                    >
                </el-row>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import HighlightSearch from "./HighlightSearch.vue";

export default {
    components: {
        HighlightSearch,
    },
    props: {
        allowImportCsv: {
            type: Boolean,
            default: true,
        },
        supplierId: String,
        productsData: Array,
        height: Number,
        isLoading: Boolean,
    },
    data: () => ({
        search: "",
    }),
    computed: {},
};
</script>

<style lang="scss" scoped>
.products-table__header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    .search-bar {
        margin-right: 10px;
    }
}
</style>

<style lang="scss">
.el-table {
    tr.products-table__row {
        td {
            padding: 3px 0;
        }
    }
}
</style>
